import { useTranslations } from "next-intl";
import React, { useEffect, useState } from "react";
import SwiperCore from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import Button from "~/components/common/button";
import { CarouselArrows, updateArrowStatus } from "~/components/editorials/carousel-utils/carousel-utils";
import { KikReviewsV2Media } from "~/shared/power-reviews-response.interface";
import prUtils from "~/utils/power-reviews-utils";

import styles from "./review-images-carousel.module.scss";
import ReviewsGalleryDialog from "./reviews-gallery-dialog";

type PropsProductReviews = {
  media?: KikReviewsV2Media[];
};

export default function ReviewImagesCarousel(props: PropsProductReviews) {
  const { media } = props;
  const t = useTranslations();
  const [swiperInstance, setSwiperInstance] = useState<SwiperCore>();
  const [arrowsStatus, setArrowsStatus] = useState({ arrowL: false, arrowR: false });
  const [startingIdForGallery, setStartingIdForGallery] = useState<string>();

  useEffect(() => {
    if (swiperInstance) setArrowsStatus(updateArrowStatus(swiperInstance));
  }, [swiperInstance]);

  // const medias = [
  //   {
  //     id: "581436027",
  //     review_id: 581436026,
  //     uri: "//res.cloudinary.com/powerreviews/image/upload/f_auto,q_auto,h_768,w_auto/d_portal-no-product-image_ttlfpi.svg/prod/w3mkznzrpkiw6qgwskhi.jpg",
  //     headline: "Angenehmes Tragegefühl und schöne Farbe",
  //     rating: 5,
  //     helpful_votes: 0,
  //     not_helpful_votes: 0,
  //     type: "image",
  //     caption: "Angenehme Textur",
  //     nickname: "Angelina",
  //     created_date: 1780512985761,
  //   },
  //   {
  //     id: "581435992",
  //     review_id: 581436026,
  //     uri: "//res.cloudinary.com/powerreviews/image/upload/f_auto,q_auto,h_768,w_auto/d_portal-no-product-image_ttlfpi.svg/prod/btqzywtgxof6uxthyizq.jpg",
  //     headline: "Angenehmes Tragegefühl und schöne Farbe",
  //     rating: 5,
  //     helpful_votes: 0,
  //     not_helpful_votes: 0,
  //     type: "image",
  //     caption: "Wunderschöner Farbton",
  //     nickname: "Angelina",
  //     created_date: 1780512985761,
  //   },
  //   {
  //     id: "573861218",
  //     review_id: 573861200,
  //     uri: "//res.cloudinary.com/powerreviews/image/upload/f_auto,q_auto,h_768,w_auto/d_portal-no-product-image_ttlfpi.svg/prod/mqs41set483y43cinfwv.jpg",
  //     headline: "Ich kaufe es noch!",
  //     rating: 5,
  //     helpful_votes: 1,
  //     not_helpful_votes: 0,
  //     type: "image",
  //     caption: "Süß",
  //     nickname: "Valeria",
  //     created_date: 1770235054605,
  //   },
  //   {
  //     id: "573844979",
  //     review_id: 487274660,
  //     uri: "//res.cloudinary.com/powerreviews/image/upload/f_auto,q_auto,h_768,w_auto/d_portal-no-product-image_ttlfpi.svg/prod/gzuyel6vib5uzfljgt3t.jpg",
  //     headline: "Comprei, estou muito satisfeita, super indico",
  //     rating: 5,
  //     helpful_votes: 0,
  //     not_helpful_votes: 0,
  //     type: "image",
  //     caption: "❤️❤️❤️",
  //     nickname: "Luciana",
  //     created_date: 1770214513308,
  //   },
  //   {
  //     id: "553110006",
  //     review_id: 553109977,
  //     uri: "//res.cloudinary.com/powerreviews/image/upload/f_auto,q_auto,h_768,w_auto/d_portal-no-product-image_ttlfpi.svg/prod/mll1cq2s7bpu96zwqgmm.jpg",
  //     headline: "Würde mir immer wieder holen",
  //     rating: 5,
  //     helpful_votes: 1,
  //     not_helpful_votes: 0,
  //     type: "image",
  //     caption: "",
  //     nickname: "Shams",
  //     created_date: 1746806247693,
  //   },
  //   {
  //     id: "529594598",
  //     review_id: 529594816,
  //     uri: "//res.cloudinary.com/powerreviews/image/upload/f_auto,q_auto,h_768,w_auto/d_portal-no-product-image_ttlfpi.svg/prod/mxk445nrogzspwpzpr4q.jpg",
  //     headline: "I would buy this product again",
  //     rating: 5,
  //     helpful_votes: 1,
  //     not_helpful_votes: 2,
  //     type: "image",
  //     caption: "",
  //     nickname: "Jamaica",
  //     created_date: 1724945929318,
  //   },
  // ];

  const onButtonClick = (id: string) => {
    setStartingIdForGallery(id);
  };

  if (!media || media.length < 1) {
    return null;
  }
  return (
    <section className={styles.reviewImagesCarousel}>
      <Swiper
        onSwiper={setSwiperInstance}
        onTransitionEnd={(currentSwiper) => setArrowsStatus(updateArrowStatus(currentSwiper))}
        slidesPerView="auto"
        slidesPerGroupAuto={true}
        spaceBetween={30}
      >
        {media.map((m, i) => {
          return (
            <SwiperSlide key={m.id} className={styles.reviewImagesSlide}>
              <Button onClick={() => onButtonClick(m.id)}>
                <div className={styles.galleryMediaCardMedia}>
                  <picture>
                    <source type="image/webp" srcSet={prUtils.getThumbnail(m.uri, "webp")}></source>
                    <source type="image/jxr" srcSet={prUtils.getThumbnail(m.uri, "jxr")}></source>
                    <img
                      alt={`${t("a11y.userSubmittedMedia", { index: i + 1, total: media.length })}. ${t(
                        "a11y.openGallery"
                      )}`}
                      src={prUtils.getThumbnail(m.uri)}
                    />
                  </picture>
                </div>
              </Button>
            </SwiperSlide>
          );
        })}
      </Swiper>
      {swiperInstance && (
        <CarouselArrows
          swiperInstance={swiperInstance}
          arrowsStatus={arrowsStatus}
          className={styles.reviewImagesArrows}
          isMobileProductGallery
        />
      )}
      {startingIdForGallery && (
        <ReviewsGalleryDialog
          onClose={() => setStartingIdForGallery(undefined)}
          startingIdForGallery={startingIdForGallery}
          media={media}
        />
      )}
    </section>
  );
}
